import { Gewest } from "domain/cities/cities";
import * as R from "ramda";

/*
F = Federaal
V = Vlaanderen
W = Wallonie
B = Brussel
*/
const data = {
  1989: { F: 49578.7 },
  1990: { F: 51115.64, V: 51115.64, W: 51115.64, B: 51115.64 },
  1991: { F: 52875.69, V: 52875.69, W: 52875.69, B: 52875.69 },
  1992: { F: 54536.58, V: 54536.58, W: 54536.58, B: 54536.58 },
  1993: { F: 54536.58, V: 54536.58, W: 54536.58, B: 54536.58 },
  1994: { F: 54536.58, V: 54536.58, W: 54536.58, B: 54536.58 },
  1995: { F: 54536.58, V: 54536.58, W: 54536.58, B: 54536.58 },
  1996: { F: 54536.58, V: 54536.58, W: 54536.58, B: 54536.58 },
  1997: { F: 54536.58, V: 54536.58, W: 54536.58, B: 54536.58 },
  1998: { F: 54536.58, V: 54536.58, W: 54536.58, B: 54536.58 },
  1999: { F: 55057.15, V: 55057.15, W: 55057.15, B: 55057.15 },
  2000: { F: 55652.1, V: 55652.1, W: 55652.1, B: 55652.1 },
  2001: { F: 57570.0, V: 57570.0, W: 57570.0, B: 57570.0 },
  2002: { F: 58990.0, V: 58990.0, W: 58990.0, B: 58990.0 },
  2003: { F: 59960.0, V: 59960.0, W: 59960.0, B: 59960.0 },
  2004: { F: 60910.0, V: 60910.0, W: 60910.0, B: 60910.0 },
  2005: { F: 62190.0, V: 62190.0, W: 62190.0, B: 62190.0 },
  2006: { F: 63920.0, V: 63920.0, W: 63920.0, B: 63920.0 },
  2007: { F: 65060.0, V: 65060.0, W: 65060.0, B: 65060.0 },
  2008: { F: 66240.0, V: 66240.0, W: 66240.0, B: 66240.0 },
  2009: { F: 69220.0, V: 69220.0, W: 69220.0, B: 69220.0 },
  2010: { F: 69220.0, V: 69220.0, W: 69220.0, B: 69220.0 },
  2011: { F: 70700.0, V: 70700.0, W: 70700.0, B: 70700.0 },
  2012: { F: 73190.0, V: 73190.0, W: 73190.0, B: 73190.0 },
  2013: { F: 75270.0, V: 75270.0, W: 75270.0, B: 75270.0 },
  2014: { F: 75270.0, V: 76110.0, W: 76110.0, B: 76110.0 },
  2015: { F: 75270.0, V: 76110.0, W: 76360.0, B: 76360.0 },
  2016: { F: 75270.0, W: 76360.0, B: 76780.0 },
  2017: { F: 75270.0, W: 76360.0 },
  2018: { F: 76860.0, W: 76360.0 },
  2019: { F: 78440.0, W: 76360.0 },
  2020: { F: 78440.0, W: 76360.0 },
  2021: { F: 78440.0, W: 76360.0 },
};

export const getLangetermijnsparenLimit = (jaarLening: string, gewest: Gewest, code: string): number => {
  if (code.startsWith("1") || code.startsWith("2")) {
    return R.pathOr(0, [jaarLening, "F"], data);
  }

  return R.pathOr(0, [jaarLening, gewest], data);
};
